module.exports = __webpack_public_path__ + "static/img/app-screens.d04304f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-screens.png
// module id = 320
// module chunks = 1